import MobileModal from './component.jsx'
export default MobileModal
